import { createSlice } from '@reduxjs/toolkit'
import {
  getChatCredentials, loginToMatrix, startMatrixClient, stopMatrixClient, refreshMatrixToken
} from 'store/chat/services'

const initialState = {
  connectionApi: null,
  chatCredentials: null,
  connectedProfile: null,
  meXmppIsOnline: false,
  meXmppProblem: null,
  xmppPushNotification: null,
  numUnread: 0,
  isXmppModalSpinnerHidden: false,
  isMobileImagePickerState: false,
  isMobileImageTransferInprogress: false,
  xmppChatPanelOpened: false,
  forceCloseChatPanel: false,
  matrixStatus: 'idle',
  matrixError: null,
  rooms: [],
  matrixMessagesbyRoomId: {},
  syncState: null,
  xmppLiveLocation: {
    lat: NaN,
    lng: NaN
  }
}

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setXmppLiveLocation: (state, { payload }) => {
      if (!payload?.latitude || !payload?.longitude) {
        return
      }
      state.xmppLiveLocation.lat = payload.latitude
      state.xmppLiveLocation.lng = payload.longitude
    },
    setXmppPushNotification: (state, { payload }) => {
      state.xmppPushNotification = payload
    },
    clearXmppPushNotification: (state) => {
      state.xmppPushNotification = null
    },
    setXmppChatPanelOpened: (state, { payload }) => {
      state.xmppChatPanelOpened = payload
    },
    setForceCloseChatPanel: (state, { payload }) => {
      state.forceCloseChatPanel = payload
    },
    hideModalSpinner: (state) => {
      state.isXmppModalSpinnerHidden = true
    },
    showModalSpinner: (state) => {
      state.isXmppModalSpinnerHidden = false
    },
    beginMobileImagePicker: (state) => {
      state.isMobileImagePickerState = true
    },
    endMobileImagePicker: (state) => {
      state.isMobileImagePickerState = false
    },
    beginMobileImageTransfer: (state) => {
      state.isMobileImageTransferInprogress = true
    },
    endMobileImageTransfer: (state) => {
      state.isMobileImageTransferInprogress = false
    },
    setMeXmppInitialState: (state) => {
      state.meXmppProblem = null
      state.meXmppIsOnline = false
    },
    setMeXmppProblem: (state, { payload }) => {
      state.meXmppProblem = payload
      console.log(`TODO: implement audit log: ${state.meXmppProblem.status}, ${state.meXmppProblem.message}`)
    },
    setMeXmppOnlineStatus: (state, { payload }) => {
      state.meXmppIsOnline = payload
    },
    openConnectedProfileChat: (state, { payload }) => {
      state.connectedProfile = payload
      const event = new CustomEvent('custom-chat-open_chat_with_friend', {
        detail: {
          recipient: payload
        }
      })
      window.dispatchEvent(event)
    },
    clearConnectedProfileChat: (state) => {
      state.connectedProfile = null
    },
    changeNumUnread: (state, { payload }) => {
      state.numUnread = payload
    },
    messageReceived: (state, action) => {
      const {
        roomId, sender, body, ts
      } = action.payload
      if (!state.matrixMessagesbyRoomId[roomId]) state.matrixMessagesbyRoomId[roomId] = []
      state.matrixMessagesbyRoomId[roomId].push({ sender, body, ts })
    },
    syncStateChanged: (state, action) => {
      state.syncState = action.payload
    }
  },
  extraReducers: ({ addCase }) => {
    addCase(getChatCredentials.fulfilled, (state, { payload }) => {
      state.chatCredentials = payload
    })
      .addCase(loginToMatrix.pending, (state) => {
        state.status = 'loggingIn'
        state.error = null
      })
      .addCase(loginToMatrix.fulfilled, (state, action) => {
        state.credentials = action.payload
      })
      .addCase(loginToMatrix.rejected, (state, action) => {
        state.status = 'error'
        state.error = action.payload
      })
    // start client
      .addCase(startMatrixClient.pending, (state) => {
        state.status = 'starting'
      })
      .addCase(startMatrixClient.fulfilled, (state, action) => {
        state.status = 'ready'
        state.rooms = action.payload.rooms
      })
      .addCase(startMatrixClient.rejected, (state, action) => {
        state.status = 'error'
        state.error = action.payload
      })
    // stop client
      .addCase(stopMatrixClient.fulfilled, (state) => {
        state.status = 'idle'
        state.rooms = []
        state.messagesByRoom = {}
      })
      .addCase(refreshMatrixToken.fulfilled, (state, action) => {
        state.credentials = {
          ...state.credentials,
          accessToken: action.payload.accessToken,
          refreshToken: action.payload.refreshToken
        }
      })
      .addCase(refreshMatrixToken.rejected, (state, action) => {
        state.status = 'error'
        state.error = action.payload
      // refresh token itself may be invalid here -- likely needs a full re-login
      })
  }
})

export const {
  setXmppLiveLocation,
  setXmppPushNotification,
  clearXmppPushNotification,
  setMeXmppInitialState,
  setMeXmppProblem,
  setMeXmppOnlineStatus,
  openConnectedProfileChat,
  clearConnectedProfileChat,
  changeNumUnread,
  hideModalSpinner,
  showModalSpinner,
  beginMobileImagePicker,
  endMobileImagePicker,
  beginMobileImageTransfer,
  endMobileImageTransfer,
  setXmppChatPanelOpened,
  setForceCloseChatPanel,
  messageReceived,
  syncStateChanged
} = chatSlice.actions

export const chatReducer = chatSlice.reducer
